import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTheme, lighten, darken } from "@mui/material/styles";
import { Stack, Typography, Popper, Fade, } from "@mui/material";
import StoreObjectIcon from "../StoreObjectIcon";
import HomeIcon from "@mui/icons-material/Home";
var TargetPopper = function (_a) {
    var open = _a.open, parent = _a.parent;
    var theme = useTheme();
    var modify = theme.palette.mode === "dark" ? darken : lighten;
    return (_jsx(_Fragment, { children: _jsx(Popper, { id: "drop-target-popper", open: open, placement: "top", transition: true, disablePortal: true, style: {
                position: "absolute",
                top: "unset",
                bottom: "16px",
                left: "calc(50% - 100px)",
                zIndex: 1,
            }, popperOptions: {
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [5, 5],
                        },
                    },
                ],
            }, children: function (_a) {
                var TransitionProps = _a.TransitionProps;
                return (_jsx(Fade, __assign({}, TransitionProps, { timeout: 350, children: _jsxs(Stack, { spacing: 1, sx: {
                            border: 0,
                            p: 1,
                            boxShadow: "0px 0px 24px rgba(40, 48, 94, 0.12)",
                            borderRadius: "16px",
                            borderColor: modify(theme.palette.secondary.dark, 0.5),
                            bgcolor: modify(theme.palette.info.light, 0.8),
                            width: "200px",
                        }, alignItems: "center", children: [_jsx(Typography, { variant: "body2", children: "Drop files to upload" }), _jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, children: [!!parent ? (_jsx(StoreObjectIcon, { type: "folder", mimeType: "" })) : (_jsx(HomeIcon, {})), !!parent && _jsx(Typography, { children: parent.name })] })] }) })));
            } }) }));
};
export default TargetPopper;
